import APIService from './APIService'

const api = APIService()

export const getSuppliers = payload => api.get(`/suppliers${payload.query}`)
export const syncSuppliers = () => api.post(`/suppliers/sync/subiekt`)
